/* eslint-disable no-param-reassign */

/**
 * Convert string to camelCase text.
 */
import lowerCase from './lowerCase';
import upperCase from './upperCase';

var camelCase = function camelCase(str) {
  return str.replace(/_|-/g, ' ') // convert all underscores & hyphens to spaces
  .toLowerCase().replace(/\s[a-z]/g, upperCase) // convert first char of each word to UPPERCASE
  .replace(/\s+/g, '') // remove spaces
  .replace(/^[A-Z]/g, lowerCase);
}; // convert first char to lowercase


export default camelCase;